export default __webpack_public_path__ + "static/media/stephen.a4d58ced.jpeg";